"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataListPage = void 0;

var base_page_1 = require("./base-page");

var maishu_wuzhui_helper_1 = require("maishu-wuzhui-helper");

var React = require("react");

var item_dialog_1 = require("./item-dialog");

var ReactDOM = require("react-dom");

var input_control_1 = require("./inputs/input-control");

var maishu_ui_toolkit_1 = require("maishu-ui-toolkit");
/** 数据绑定列控件 */


var BoundFieldControl = /*#__PURE__*/function (_input_control_1$Inpu) {
  _inherits(BoundFieldControl, _input_control_1$Inpu);

  var _super = _createSuper(BoundFieldControl);

  function BoundFieldControl(props) {
    var _this;

    _classCallCheck(this, BoundFieldControl);

    _this = _super.call(this, props);
    _this.state = {};
    return _this;
  }

  _createClass(BoundFieldControl, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      console.assert(this.state != null);
      return React.createElement("span", {
        ref: function ref(e) {
          if (_this2.control != null) {
            return;
          }

          _this2.control = _this2.props.boundField.createControl();

          _this2.control.element.setAttribute("name", _this2.props.dataField);

          _this2.control.value = _this2._value;

          _this2.control.element.onchange = function () {
            _this2._value = _this2.control.value;
          };

          e.appendChild(_this2.control.element);
        }
      });
    }
  }, {
    key: "value",
    get: function get() {
      return this._value;
    },
    set: function set(value) {
      this._value = value;
      if (this.control != null) this.control.value = value;
    }
  }]);

  return BoundFieldControl;
}(input_control_1.InputControl);

var DataListPage = /*#__PURE__*/function (_base_page_1$BasePage) {
  _inherits(DataListPage, _base_page_1$BasePage);

  var _super2 = _createSuper(DataListPage);

  function DataListPage(props) {
    var _this3;

    _classCallCheck(this, DataListPage);

    _this3 = _super2.call(this, props);
    /** 操作列宽度 */

    _this3.CommandColumnWidth = 140;
    _this3.ScrollBarWidth = 18; //============================================
    // protected

    _this3.pageSize = 15;
    _this3.headerFixed = false;
    /** 是否显示命令字段 */

    _this3.showCommandColumn = true;
    window.addEventListener("resize", function () {
      var height = window.innerHeight - 160;
      var width = window.innerWidth - 80;
      var firstMenuPanel = document.getElementsByClassName("first")[0];
      var secondMenuPanel = document.getElementsByClassName("second")[0];

      if (firstMenuPanel) {
        width = width - firstMenuPanel.offsetWidth;
      }

      if (secondMenuPanel) {
        width = width - secondMenuPanel.offsetWidth;
      }

      var tableSize;

      if (_this3.state != null) {
        tableSize = _this3.state.tableSize;
      }

      if (tableSize == null || tableSize.height != height || tableSize.width != width) {
        _this3.setState({
          tableSize: {
            width: width,
            height: height
          }
        });
      }
    });
    return _this3;
  }

  _createClass(DataListPage, [{
    key: "calcTableSize",
    value: function calcTableSize() {
      var height = window.innerHeight - 160;
      var width = window.innerWidth - 40;
      var firstMenuPanel = document.getElementsByClassName("first")[0];
      var secondMenuPanel = document.getElementsByClassName("second")[0];

      if (firstMenuPanel) {
        width = width - firstMenuPanel.offsetWidth;
      }

      if (secondMenuPanel) {
        width = width - secondMenuPanel.offsetWidth;
      }

      return {
        width: width,
        height: height
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.columns = this.columns || [];

      if (this.showCommandColumn) {
        var it = this;
        this.commandColumn = new maishu_wuzhui_helper_1.CustomField({
          headerText: "操作",
          headerStyle: {
            textAlign: "center",
            width: "".concat(this.CommandColumnWidth, "px")
          },
          itemStyle: {
            textAlign: "center",
            width: "".concat(this.CommandColumnWidth, "px")
          },
          createItemCell: function createItemCell(dataItem, cellElement) {
            var cell = new maishu_wuzhui_helper_1.GridViewCell(cellElement);
            ReactDOM.render(React.createElement(React.Fragment, null, it.leftCommands(dataItem), it.editButton(dataItem), it.deleteButton(dataItem), it.rightCommands(dataItem)), cell.element);
            return cell;
          }
        });
      }

      maishu_wuzhui_helper_1.createGridView({
        element: this.itemTable,
        dataSource: this.dataSource,
        columns: this.commandColumn ? [].concat(_toConsumableArray(this.columns), [this.commandColumn]) : this.columns,
        pageSize: this.pageSize,
        translate: this.translate,
        showHeader: this.headerFixed != true
      });
    }
  }, {
    key: "renderEditor",
    value: function renderEditor() {
      return React.createElement(React.Fragment, null, this.columns.filter(function (o) {
        return o instanceof maishu_wuzhui_helper_1.BoundField && o.readOnly != true;
      }).map(function (col, i) {
        return React.createElement("div", {
          key: i,
          className: "form-group clearfix input-control"
        }, React.createElement("label", null, col.headerText), React.createElement(BoundFieldControl, {
          boundField: col,
          dataField: col.dataField,
          validateRules: col.validateRules
        }));
      }));
    }
  }, {
    key: "renderToolbarRight",
    value: function renderToolbarRight() {
      var editor = this.renderEditor();

      if (editor == null) {
        return [];
      }

      this.dialog = item_dialog_1.createItemDialog(this.dataSource, this.itemName, editor);
      var addButton = this.addButton();
      var searchInput = this.searchControl();
      return [searchInput, addButton];
    }
    /** 获取页面添加按钮 */

  }, {
    key: "addButton",
    value: function addButton() {
      var _this4 = this;

      var button = this.dataSource.canInsert ? React.createElement("button", {
        key: "btnAdd",
        className: "btn btn-primary btn-sm",
        onClick: function onClick() {
          return _this4.dialog.show({});
        }
      }, React.createElement("i", {
        className: "icon-plus"
      }), React.createElement("span", null, "\u6DFB\u52A0")) : null;
      return button;
    }
    /** 获取页面编辑按钮 */

  }, {
    key: "editButton",
    value: function editButton(dataItem) {
      var _this5 = this;

      if (!this.dataSource.canUpdate) return null;
      var ps = this.dataSource;
      var options = ps.options || {};

      var itemCanUpdate = options.itemCanUpdate || function () {
        return true;
      };

      return React.createElement("button", {
        className: "btn btn-minier btn-info",
        onClick: function onClick() {
          return _this5.executeEdit(dataItem);
        },
        disabled: !itemCanUpdate(dataItem)
      }, React.createElement("i", {
        className: "icon-pencil"
      }));
    }
    /** 获取页面删除按钮 */

  }, {
    key: "deleteButton",
    value: function deleteButton(dataItem) {
      var _this6 = this;

      if (!this.dataSource.canDelete) return;
      var ps = this.dataSource;
      var options = ps.options || {};

      var itemCanDelete = options.itemCanDelete || function () {
        return true;
      };

      return React.createElement("button", {
        className: "btn btn-minier btn-danger",
        disabled: !itemCanDelete(dataItem),
        ref: function ref(e) {
          if (!e) return;

          if (e.getAttribute("button-on-click")) {
            return;
          }

          e.setAttribute("button-on-click", "true");
          maishu_ui_toolkit_1.buttonOnClick(e, function () {
            return _this6.executeDelete(dataItem);
          });
        }
      }, React.createElement("i", {
        className: "icon-trash"
      }));
    }
    /** 执行编辑操作 */

  }, {
    key: "executeEdit",
    value: function executeEdit(dataItem) {
      this.dialog.show(dataItem);
    }
    /** 执行删除操作 */

  }, {
    key: "executeDelete",
    value: function executeDelete(dataItem) {
      var _this7 = this;

      if (this.deleteConfirmText) {
        var message = this.deleteConfirmText(dataItem);
        return new Promise(function (resolve, reject) {
          maishu_ui_toolkit_1.confirm({
            title: "请确认",
            message: message,
            confirm: function () {
              var _confirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        return _context.abrupt("return", _this7.dataSource.delete(dataItem).then(function (r) {
                          return resolve(r);
                        }).catch(function (err) {
                          return reject(err);
                        }));

                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              function confirm() {
                return _confirm.apply(this, arguments);
              }

              return confirm;
            }(),
            cancle: function () {
              var _cancle = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        resolve({});

                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              function cancle() {
                return _cancle.apply(this, arguments);
              }

              return cancle;
            }()
          });
        });
      }

      return this.dataSource.delete(dataItem);
    }
    /** 获取页面搜索栏 */

  }, {
    key: "searchControl",
    value: function searchControl() {
      var dataSource = this.dataSource;
      var search = dataSource.options ? dataSource.options.search : null;
      var searchInput = search ? React.createElement(React.Fragment, null, React.createElement("input", {
        type: "text",
        className: "form-control pull-left input-sm",
        placeholder: search.placeholder || "",
        style: {
          width: 300
        }
      }), React.createElement("button", {
        className: "btn btn-primary btn-sm"
      }, React.createElement("i", {
        className: "icon-search"
      }), React.createElement("span", null, "\u641C\u7D22"))) : null;
      return searchInput;
    }
  }, {
    key: "rightCommands",
    value: function rightCommands(dataItem) {
      return [];
    }
  }, {
    key: "leftCommands",
    value: function leftCommands(dataItem) {
      return [];
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var tableSize = this.state ? this.state.tableSize : this.calcTableSize();

      if (this.headerFixed) {
        var columns = this.columns || [];
        return React.createElement(React.Fragment, null, React.createElement("div", {
          style: {
            height: "".concat(tableSize.height, "px"),
            width: "".concat(tableSize.width, "px"),
            overflowY: "scroll",
            overflowX: "hidden"
          }
        }, React.createElement("table", {
          className: "table table-striped table-bordered table-hover",
          style: {
            margin: 0
          }
        }, React.createElement("thead", null, React.createElement("tr", null, columns.map(function (col, i) {
          return React.createElement("th", {
            key: i,
            ref: function ref(e) {
              if (!e) return;
              if (!col.itemStyle) return;
              e.style.width = col.itemStyle["width"];

              if (_this8.commandColumn == null && i == columns.length - 1) {
                e.style.width = "calc(".concat(e.style.width, " + ").concat(_this8.ScrollBarWidth, "px)");
              }
            }
          }, col.headerText);
        }), this.commandColumn ? React.createElement("th", {
          style: {
            width: this.CommandColumnWidth + this.ScrollBarWidth
          }
        }, this.commandColumn.headerText) : null))), React.createElement("table", {
          ref: function ref(e) {
            return _this8.itemTable = e || _this8.itemTable;
          }
        })));
      }

      return React.createElement("table", {
        ref: function ref(e) {
          return _this8.itemTable = e || _this8.itemTable;
        }
      });
    }
  }, {
    key: "boundField",
    value: function boundField(params) {
      return maishu_wuzhui_helper_1.boundField(params);
    }
  }, {
    key: "dateTimeField",
    value: function dateTimeField(params) {
      return maishu_wuzhui_helper_1.dateTimeField(params);
    }
  }, {
    key: "checkboxListField",
    value: function checkboxListField(params) {
      return maishu_wuzhui_helper_1.checkboxListField(params);
    }
  }]);

  return DataListPage;
}(base_page_1.BasePage);

exports.DataListPage = DataListPage;
